import React from 'react';
import { Link } from 'react-router-dom';
import './Ebook.css';

const Ebook = () => {
  return (
    <div className="ebook-paywall" data-testid="ebook-inquiry-page">
      <div className="paywall-container">
        <div className="paywall-hero">
          <span className="section-label">Premium E-Book</span>
          <h1 className="paywall-title">
            Der große<br />
            <span className="gold">Social Media Guide</span>
          </h1>
          <p className="paywall-subtitle">
            Das komplette Premium E-Book mit über 23 Kapiteln und 25.000+ Wörtern
            hochwertigem Marketing-Wissen für nachhaltigen Social-Media-Erfolg.
          </p>
        </div>

        <div className="paywall-grid">
          {/* Left: What's inside */}
          <div className="paywall-features">
            <h2>Was dich erwartet:</h2>
            <ul className="features-list">
              <li>
                <span className="feature-icon">📖</span>
                <div>
                  <strong>23 ausführliche Kapitel</strong>
                  <p>Von Grundlagen bis Profi-Strategien – alles strukturiert aufbereitet.</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">🎯</span>
                <div>
                  <strong>Praxiserprobte Strategien</strong>
                  <p>Konkrete Anleitungen für Instagram, TikTok, LinkedIn und Co.</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">🧠</span>
                <div>
                  <strong>Psychologische Insights</strong>
                  <p>Verstehe, was Menschen wirklich anspricht – und nutze es für dein Marketing.</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">💡</span>
                <div>
                  <strong>Algorithmus-Geheimnisse</strong>
                  <p>So funktionieren die Algorithmen wirklich – und so nutzt du sie.</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">📊</span>
                <div>
                  <strong>Analytics & KPIs</strong>
                  <p>Welche Zahlen wirklich zählen – und wie du sie optimierst.</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">💰</span>
                <div>
                  <strong>Monetarisierung</strong>
                  <p>So machst du aus Social Media echtes Business.</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Right: Buy Card */}
          <div className="paywall-purchase">
            <div className="price-card">
              <div className="price-badge">Premium</div>
              <div className="price-amount">
                <span className="price-value">29,99&nbsp;€</span>
              </div>
              <p className="price-description">
                Einmaliger Kaufpreis. Kein Abo, keine versteckten Kosten.
              </p>

              <ul className="price-features">
                <li>✓ Alle 23 Kapitel als PDF</li>
                <li>✓ Lesen am Handy, Tablet, PC</li>
                <li>✓ Drucken & für später speichern</li>
                <li>✓ Persönliche Beratung von Niels</li>
                <li>✓ Sofort verfügbar nach Zahlung</li>
              </ul>

              <Link
                to="/kontakt?interesse=E-Book%20kaufen%20(29,99%20€)"
                className="buy-button"
                data-testid="ebook-buy-button"
              >
                Jetzt kaufen für 29,99 €
                <span className="btn-arrow">→</span>
              </Link>

              <p className="secure-info">
                💬 Kontaktiere Niels persönlich für den Kauf<br />
                Zahlungsdetails erhältst du direkt.
              </p>
            </div>

            <p className="guarantee">
              ✨ Einmalzahlung · Kein Abo · Sofort verfügbar
            </p>
          </div>
        </div>

        <div className="paywall-cta">
          <p>Lieber direkt sprechen?</p>
          <Link to="/buchen" className="contact-link" data-testid="ebook-booking-link">
            Kostenloses Erstgespräch buchen →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Ebook;
